import { useSwiperSlide } from "swiper/react";
import { audio_click } from "../lib/SoundManager";
import React, { useState } from "react";
import Popup from "./Popup";

export default function App() {
  const swiperSlide = useSwiperSlide();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let [title, setTitle] = useState("images/03/03/popup_title1.png");
  let [contents, setContents] = useState("images/03/03/contents1.png");
  
  if (!swiperSlide.isActive) {
    return <></>;
  }
  return (
    <>
      <img
        style={{
          position: "absolute",
          top: "76px",
          left: "121px",
        }}
        src="images/03/03/subtitle.png"
      ></img>
      <img
        onClick={() => {
          audio_click();
          setIsDialogOpen(true);
          setTitle("images/03/03/popup_title1.png");
          setContents("images/03/03/contents1.png");
        }}
        style={{
          position: "absolute",
          top: "180px",
          left: "110px",
          cursor: "pointer",
        }}
        src="images/03/03/btn_1.png"
      />
      <img
        onClick={() => {
          audio_click();
          setIsDialogOpen(true);
          setTitle("images/03/03/popup_title2.png");
          setContents("images/03/03/contents2.png");
        }}
        style={{
          position: "absolute",
          top: "380px",
          left: "110px",
          cursor: "pointer",
        }}
        src="images/03/03/btn_2.png"
      />
      {isDialogOpen && (
        <>
          <Popup
            onClose={() => {
              setIsDialogOpen(false);
            }}
            title={title}
          >
            <img src={contents}/>
          </Popup>
        </>
      )}
      <img
        onClick={() => {
          audio_click();
          setIsDialogOpen(true);
          setTitle("images/03/03/popup_title3.png");
          setContents("images/03/03/contents3.png");
        }}
        style={{
          position: "absolute",
          top: "580px",
          left: "110px",
          cursor: "pointer",
        }}
        src="images/03/03/btn_3.png"
      />
      {isDialogOpen && (
        <Popup
          onClose={() => {
            setIsDialogOpen(false);
          }}
          title={title}
          style={{
            title: {
              paddingBottom: "10px"
            },
            content: {
              background: "#2d4583",
              padding: "40px"
            }
          }}
        >
          <img src={contents}/>
        </Popup>
      )}
    </>
  );
}
